import { render } from "./LeftNavbar.vue?vue&type=template&id=30530c3c&scoped=true"
import script from "./LeftNavbar.vue?vue&type=script&lang=js"
export * from "./LeftNavbar.vue?vue&type=script&lang=js"

import "./LeftNavbar.vue?vue&type=style&index=0&id=30530c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30530c3c"]])

export default __exports__